import { Config } from '../config';

/**
 * Get the collection name with appropriate prefix based on environment
 * @param collectionName - The base collection name
 * @returns The collection name with 'dev_' prefix in development
 */
export function getCollectionName(collectionName: string): string {
    // Add 'dev_' prefix in development mode
    return Config.Env.isDevelopment ? `dev_${collectionName}` : collectionName;
}